import {Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import { FormControl } from '@angular/forms';
import {ApiService} from '../shared/api.service';
import {NotificationService} from '../shared/notification.service';
import { Subscription } from 'rxjs';
import { NgxLinkifyjsService } from 'ngx-linkifyjs';

@Component({
    selector: 'notes-component',
    templateUrl: 'notes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotesComponent {
    comments = [];
    commentSubscription: Subscription;
    control = new FormControl();
    float = 'auto';
    loadCommentsSubscription: Subscription;
    user;

    @Input() assignment;
    @Input() reference;
    @Input() id;
    @Input() placeholder;
    @Output() commentsChange = new EventEmitter();

    constructor(private linkService: NgxLinkifyjsService , private cdr: ChangeDetectorRef, private api: ApiService, private notifyService: NotificationService) {
        this.user = api.getProp('user');
    }
    ngAfterViewInit() {
        this.setPlaceholder();
        this.loadComments();
        this.cdr.markForCheck();
    }
    addComment(e) {
        e.preventDefault();
        let value = this.control.value;
        if( !value ) {
            return;
        }
        let user = this.user;
        let id = this.id;
        let date = new Date().toISOString();
        let reference = this.reference || '';
        let comment = {
            author: user.id,
            abbreviation: user.abbreviation,
            role: user.role,
            content: value,
            text: value,
            date: date,
            post: id,
            reference: reference
        };
        this.comments.unshift(comment);
        this.commentsChange.emit(this.comments);
        this.control.setValue('');
        
        if( id ) {
            this.commentSubscription = this.api.doAction('post', 'comment', {
                action: 'create',
                comment: comment
            }).subscribe(
                data => {
                    this.notifyService.comment(comment, this.assignment);
                }
            );
        }
    }
    setPlaceholder() {
        let placeholder = this.placeholder;
        if( !placeholder ) {
            this.placeholder = 'Notes';
        }
    }
    loadComments() {
        let id = this.id;
        if( id ) {
            this.loadCommentsSubscription = this.api.doAction('post', 'comment', {
                action: 'read',
                post: id,
                reference: this.reference
            }).subscribe(
                data => {
                    this.comments = data;
                    this.commentsChange.emit(this.comments);
                    if( this.comments.length > 0 ) {
                        this.float = 'always';
                    }
                    this.cdr.markForCheck();
                }
            );
        }
    }
    resetComments() {
        this.comments = [];
        this.cdr.markForCheck();
    }
    ngOnDestroy() {
        if( this.loadCommentsSubscription ) {
            this.loadCommentsSubscription.unsubscribe();
        }        
        if( this.commentSubscription ) {
            this.commentSubscription.unsubscribe();
        }
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/notes.component.ts